import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { DbService, RegistrationEvent } from './service/db-service.service';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
/*rxjs imports*/ 
import { AddUserParamAction, FetchUserParamAction } from './store/actions/userparam.action';
import { IAppState } from './models/app.state.model';
import { UserParamService } from './service/userparams.service';
import { IUserParam } from './models/userparam.model';
import { IRegistrationEntry } from './models/registrationentry.model';
import { IRegistrationEvent } from './models/registrationevent.model';
import { RegistrationEntryService } from './service/registrationentry.service';
import { RegistrationEventService } from './service/registrationevent.service';
import { Store } from '@ngrx/store';
import { FetchRegistrationEntryAction } from './store/actions/registrationentry.action';
import { AddRegistrationEventAction, FetchRegistrationEventAction } from './store/actions/registrationevent.action';
import { Headercomponent } from "./headercomponent/headercomponent";
import { MatProgressBar } from "@angular/material/progress-bar";
//localhost:4200/?link=VqMLwf4hAqu9C8fkE0eN
//https://landing.ceeyu.us/?link=pNIGp2SdlzvA2TdgPu5A
//localhost:4200/?link=pNIGp2SdlzvA2TdgPu5A
@Component({
    selector: 'ceeyu-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, Headercomponent, MatProgressBar],
    providers: [UserParamService, RegistrationEntryService, RegistrationEventService]
})
export class AppComponent implements OnInit{
  title = 'landing';
  linkId: string;
  myIP: string;
  phone: string;
  email: string;
  spemail: string;
  spname: string;
  personid: any;
  docid: string;
  eventid: string;
  eventtitle: string;
  visitorName: any;
  busy = true;
  errorMode = true;
  cookieService = inject(CookieService);
  cookieValue: string;
  initDataLoad: Promise<any>[] = [];
  progressValue: number = 0;
  mode = "unknown";
  message = "Your link has expired or is invalid.";
  private intervalId: any;
  constructor(private store: Store<IAppState>,
    private userParamService: UserParamService, private registerEntryService: RegistrationEntryService,
    private registrationEventService: RegistrationEventService, public dbService: DbService, private router:Router, 
    private http: HttpClient,public activatedRoute: ActivatedRoute, private matIconRegistry: MatIconRegistry, 
    private domSanitizer: DomSanitizer) {
      this.activatedRoute.queryParams.subscribe(params => {
      this.linkId = params["link"];
      this.processLinkId();
      });
      
  }

    async joinEvent(){
      firstValueFrom(this.dbService.processJoinRequest(this.eventid, this.phone, this.http))
      .then((resp) =>{
        const tempEvt = resp["QueryResults"][0];
        if(tempEvt){
           const selectedEvent: RegistrationEvent = {
          fromdate: tempEvt["fromdate"],
          todate: tempEvt["todate"],
          eventstarttime: tempEvt["starttime"],
          bk: this.dbService.bk,
          spname: tempEvt["spname"],
          spemail: tempEvt["spemail"],
          spphone: tempEvt["spphone"],
          status: tempEvt["status"],
          cachestatus: false,
          docid: this.eventid,
          eventid: this.eventid,
          firstexpiration: tempEvt["firstexpiration"],
          title: this.eventtitle
        };
        console.log("selected event is:" + JSON.stringify(selectedEvent));
        this.dbService.selectedEvent = selectedEvent;
        this.busy = false;
        this.router.navigate(['eventsummary'], { skipLocationChange: true});
      }else{
        this.busy = false;
        this.errorMode = true;
        this.message = "Sorry. The event you are trying to reach is no longer avaialable.";
      }
	     
    });
  }

  ngOnInit(): void {
    if(!this.errorMode){
      this.startProgress();
    this.userParamService.getInitialTaskData().subscribe(
            (data: IUserParam[]) => this.store.dispatch(new FetchUserParamAction(data))
    );
    this.registerEntryService.getInitialTaskData().subscribe(
            (data: IRegistrationEntry[]) => this.store.dispatch(new FetchRegistrationEntryAction(data))
    );
    this.registrationEventService.getInitialTaskData().subscribe(
            (data: IRegistrationEvent[]) => this.store.dispatch(new FetchRegistrationEventAction(data))
    );
    }
       
  }

  processLinkId():void{
    if(this.linkId != undefined){
        firstValueFrom(this.dbService.getUserParams(this.linkId, this.http))
        .then((resp) => {
            const tempRes = resp["resolved"];
            if(tempRes != undefined && tempRes["eventid"].length > 0){
              this.errorMode = false;
              this.phone = tempRes["phone"];
              this.myIP = tempRes["myip"];
              this.email = tempRes["email"];
              this.spemail = tempRes["email"];
              this.eventid = tempRes["eventid"];
              this.eventtitle = tempRes["eventtitle"];
              this.dbService.visitorName = tempRes["visitorname"];
              if(this.eventid == "TBD"){
                this.mode = 'createnewevent';
              }else{
                this.mode = 'eventsummary';
              }
              this.cookieValue = this.cookieService.get('ipverified');
              const cookieverified = (this.cookieValue != undefined && this.cookieValue != null && this.cookieValue != "");
              this.loginUsingPhone(cookieverified)
              .then((result: boolean) => {
                this.busy = false;
                if(result){
                  switch (this.mode){
                    case 'createnewevent':
                       this.router.navigate(['createnewevent'], {skipLocationChange: true, state: {prev: "appcomponent", bk: this.personid, personid: this.personid, phone: this.phone}}); 
                    break;
                    case 'eventsummary':
                      this.dbService.id = this.eventid;
                      this.dbService.title = this.eventtitle;
                      this.dbService.phone = this.phone;
                      
                      this.joinEvent();
                     // this.router.navigate(['eventsummary'], { skipLocationChange: true, state: this.dbService});
                      break;
                  }
                }
              })
              this.matIconRegistry.addSvgIcon(
      'edit',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/edit.svg'));
      this.matIconRegistry.addSvgIcon(
        'block',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/block.svg'));
       this.matIconRegistry.addSvgIcon(
        'pinvoke',
        this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/pinvoke.svg'));

            }
            this.busy = false;
            console.log("error in link");
          });
        }
  }

  updateProgress(newValue: number) {
    this.progressValue = newValue;
  }

  startProgress(): void {
    this.intervalId = setInterval(() => {
      this.progressValue += 5;
      if (this.progressValue >= 100) {
        this.progressValue = 100;
        clearInterval(this.intervalId);
      }
    }, 500); // Update every half second
  }
  
  async loginUsingPhone(cookieverified: boolean): Promise<boolean> {
      const result = await firstValueFrom(this.dbService.signin(this.phone, this.email, this.http))
      .then((resp) => {
        //this.updateProgress(50);
        if (resp["status"] === "pass") {
          this.cookieService.set('ipverified', Date.now().toString(), 7);
          const temp = resp["QueryResults"];
          this.phone = temp[0]["phone"];
         // this.spemail = temp[0]["email"];
          this.docid = temp[0]["docid"];
          //this.visitorName = temp[0]["name"];
          this.personid = temp[0]["docid"];
          this.dbService.bk = this.personid;
          const userParam: IUserParam = {
            id: 3,
            linkid: this.linkId,
            complete: true,
            phone: this.phone,
            spemail: this.spemail,
            spname: this.spname,
            myIP: this.myIP,
            cookieverified: cookieverified,
            visitorName: this.dbService.visitorName,
            personid: this.personid
          }
          this.addUserParam(userParam);
          //this.checkForEvents(cookieverified);
          return true;
        }
        return false;
      })
      .catch(() => {
        return false;
      });
      return result;
  }
   
  
  addUserParam(userParam: IUserParam) {
    this.store.dispatch(new AddUserParamAction(userParam));
  }

  addRegisteredEvent(event: IRegistrationEvent, id: number = 0) {
    event.id= id;
    event.complete = false;
    this.store.dispatch(new AddRegistrationEventAction(event));
  }
}
